import { render, staticRenderFns } from "./ClientEditTabSocial.vue?vue&type=template&id=6aa9d732&"
import script from "./ClientEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports